import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../../data";
import Select from "react-select";
import SelectSearch from "react-select-search";

const MySwal = withReactContent(Swal2);

const AdditionalPozw = (props) => {
  const [court, setCourt] = useState("");
  const [wps, setWps] = useState("");
  const [loading, setLoading] = useState(true);
  const [clientId, setClientId] = useState(+props.clientId);
  const [courtOptions, setCourtOptions] = useState([]);

  const fetchClientData = async () => {
    var body3 = {
      id: +props.clientId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body3),
    })
      .then((response) => response.json())
      .then((data) => {
        setWps(data[0].wps);
        setCourt(data[0].court);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchClientData();
    setCourtOptions(createCourtOptions());
  };

  useEffect(() => {
    getData();
  }, []);

  const handleWpsChange = (e) => {
    setWps(e.target.value);
  };

  const handleCourtChange = (e) => {
    setCourt(e.value);
  };

  const addClientContact = async (e) => {
    if (validatePayment()) {
      setLoading(true);
      var body = {
        court: court,
        wps: wps,
        id: clientId,
        uName: props.uName,
      };

      await fetch("https://apidevkppp.ftpeople.pl/setClientPozw", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction("Zmieniono dane sprawy klienta", props.clientId);

      props.close();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (wps.length > 0 && court.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const createCourtOptions = (e) => {
    var bankOptions = [];
    bankOptions.push({
      label: "Do decyzji prawnika",
      value: "Do decyzji prawnika",
    });
    props.courtsData.map((el) => {
      bankOptions.push({ label: el.name, value: el.name });
    });

    return bankOptions;
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id="popUpLoading" />
      ) : (
        <>
          <div id="addPaymentIC" className="inputContainer">
            <div className="inputBox">
              <div style={{ width: "100%" }} className="inputCol_3">
                <label>
                  Sąd <span className="requiredStar">*</span>
                </label>
                <Select
                  noOptionsMessage={() => "Brak danych"}
                  placeholder={"Wybierz..."}
                  isClearable={false}
                  options={courtOptions}
                  onChange={handleCourtChange}
                />
              </div>
            </div>

            <div className="inputBox">
              <div style={{ width: "100%" }} className="inputCol_3">
                <label>
                  WPS <span className="requiredStar">*</span>
                </label>
                <input
                  type="number"
                  id="name"
                  name="name"
                  value={wps}
                  onChange={handleWpsChange}
                />
              </div>
            </div>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={addClientContact}>
                zapisz
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdditionalPozw;
